import './index-metric-search.style.scss'

class indexMetricSearchController {

}

export default indexMetricSearchController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-search/index-metric-search.controller.js